import React from "react";
import Logo from "../assets/images/logos/Materials Index Logo Square [color].png";
import BG from "../assets/images/wallpaper/home-bg.jpg";

function Home() {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-screen"
        style={{
          backgroundImage: `url(${BG})`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            Welcome To
            <span className="text-blue-400"> Materials Index</span>
          </h1>
          <p className="text-sm sm:text-base md:text-xl text-yellow-400">
            All Kinds of Machineries Indenting Firm
          </p>
        </div>
      </section>

      {/* 2nd Section */}
      <section className="bg-gray-50 py-12 px-4 sm:px-6">
        <div className="container mx-auto flex flex-col lg:flex-row items-center lg:justify-between space-y-8 lg:space-y-0 lg:space-x-8">
          {/* Text Content */}
          <div className="lg:w-1/2">
            <h2 className="text-blue-500 font-semibold text-lg sm:text-xl uppercase">
              Welcome To
            </h2>
            <h1 className="text-gray-800 text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
              Materials Index
            </h1>
            <div className="w-12 h-1 bg-yellow-500 mb-4"></div>
            <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed">
            Innovative in approach and committed to excellence, we offer an extensive range of advanced garment machinery solutions, meticulously designed to enhance production efficiency and elevate fabric quality. From cutting-edge stitching machines to precision-driven finishing equipment, our products are crafted to meet the diverse needs of the garment industry while optimizing operational costs. True to our mission, “We don’t just build machines; we empower your creations to come to life.”
            </p>
          </div>

          {/* Image Content */}
          <div className="lg:w-1/2 flex justify-center">
            <img
              src={Logo}
              alt="Materials Index"
              className="rounded-lg shadow-lg w-full max-w-[200px] sm:max-w-[250px] lg:max-w-[300px]"
            />
          </div>
        </div>
      </section>

      {/* Support & Services Section */}
      <section className="bg-gray-50 py-12 px-4 sm:px-6">
        <div className="container mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Our <span className="text-yellow-500">Support & Services</span>
          </h2>
          <div className="w-12 h-1 bg-yellow-500 mx-auto mb-8"></div>

          {/* Grid Content */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-gray-100 p-6 rounded-lg shadow">
              <div className="text-green-500 text-3xl sm:text-4xl mb-4">
                <i className="fas fa-cogs"></i> {/* Replace with your icon */}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-blue-600 mb-2">
                Technical Service
              </h3>
              <p className="text-gray-600 text-sm sm:text-base">
                Our reliable and experienced technical service team at Materials Index is professional.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-gray-100 p-6 rounded-lg shadow">
              <div className="text-green-500 text-3xl sm:text-4xl mb-4">
                <i className="fas fa-shipping-fast"></i> {/* Replace with your icon */}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-blue-600 mb-2">
                Delivery
              </h3>
              <p className="text-gray-600 text-sm sm:text-base">
                Keeping your convenience in consideration, our professionally
                trained delivery team are prepared 24/7.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-gray-100 p-6 rounded-lg shadow">
              <div className="text-green-500 text-3xl sm:text-4xl mb-4">
                <i className="fas fa-chalkboard-teacher"></i> {/* Replace with your icon */}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-blue-600 mb-2">
                Training
              </h3>
              <p className="text-gray-600 text-sm sm:text-base">
                We work together with our valued customers to make sure they get
                full value from our innovative solutions.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
